import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  borderRadius16,
  borderRadius8,
} from 'approot/shared/styles/borders.style';
import { coolGrey1, grey1, grey5 } from 'approot/shared/styles/colours.style';
import {
  spacing4,
  spacing12,
  spacing16,
} from 'approot/shared/styles/spacing.style';
import { font16 } from 'approot/shared/styles/typography.style';
import { viewportMaxCss } from '../shared/playable.style';
import { flexColumnCss, baseFlexCss } from 'approot/shared/styles/flex.style';

type PrintStimulusContainerProps = {
  $fullBorderRadius?: boolean;
};

export const PrintStimulusContainer = styled.div<PrintStimulusContainerProps>`
  ${viewportMaxCss}
  border: 1px solid ${grey5};
  background-color: ${coolGrey1};

  ${({ $fullBorderRadius }) =>
    $fullBorderRadius
      ? `
    border-bottom: 1px solid ${grey5};
    border-radius: ${rem(borderRadius16)};
  `
      : `
    border-bottom: 0;
    border-radius: ${rem(borderRadius16)} ${rem(borderRadius16)} 0 0;
  `}

  overflow: hidden;
  position: relative;
`;

type PrintStimulusInnerProps = {
  $backgroundImg?: string | null;
};

export const PrintStimulusAspectRatioInner = styled.div<
  PrintStimulusInnerProps & PrintStimulusContainerProps
>`
  position: relative;

  ${({ $backgroundImg }) =>
    $backgroundImg &&
    `
    background-image: url(${$backgroundImg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  `}

  border-radius: ${({ $fullBorderRadius }) =>
    $fullBorderRadius
      ? rem(borderRadius8)
      : `${rem(borderRadius8)} ${rem(borderRadius8)} 0 0`};
`;

const basePrintLink = css`
  width: 100%;
  height: 100%;
  max-width: ${rem(64)};
  max-height: ${rem(64)};
  position: relative;
  overflow: hidden;
  margin-right: ${rem(spacing16)};

  svg {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  &:before {
    content: '';
    width: 100%;
    padding-top: 100%;
    display: inline-block;
  }
`;

export const PrintStimulusImageContainer = styled.div`
  ${basePrintLink}
`;

export const PrintStimulusImageContainerLink = styled.a`
  ${basePrintLink}
`;

export const PrintStimulusImageContainerNarrow = styled.div`
  ${basePrintLink}
  margin-right: 0;
  margin-bottom: ${rem(spacing16)};
`;

export const PrintStimulusImageContainerNarrowLink = styled.a`
  ${basePrintLink}
  margin-right: 0;
  margin-bottom: ${rem(spacing16)};
`;

export const PrintStimulusLink = styled.div`
  ${baseFlexCss}
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  padding: ${rem(spacing12)};
`;

export const PrintStimulusLinkNarrow = styled.div`
  ${flexColumnCss}

  align-items: flex-start;
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  padding: ${rem(spacing12)};
`;

export const PrintStimulusText = styled.div`
  ${font16}
  margin-bottom: ${rem(spacing4)};
`;

export const PrintStimulusCol = styled.div`
  flex-grow: 1;
`;

export const PrintStimulusLinkWrapper = styled.div`
  overflow-wrap: anywhere;
`;
